import React from "react";

export function PriceTag({ price, originalPrice }) {
  return (
    <div className="price-tag inline-flex items-center gap-2 px-3 py-1">
      <span className="tag-hole"></span>
      <span style={{ fontFamily: "'JetBrains Mono', monospace" }} className="text-sm">
        {originalPrice && <span className="line-through mr-2 opacity-50">₹{originalPrice}</span>}
        ₹{price}
      </span>
    </div>
  );
}

export default PriceTag;
